// extracted by mini-css-extract-plugin
module.exports = {"arrow-link":"ArrowLink_arrow-link__XslfX","arrow-link__content":"ArrowLink_arrow-link__content__PNe_j"};